import {wxAuthBase} from '../utils/wxUtils';
// import {Toast} from 'mint-ui';
export default {
	/**
	 * 处理最近搜索，排除重复名称，最新搜索的放在顶上
	 */
	dealSearchName({commit, state}, params) {
		const {type, temple_name} = params;
		let newArr = [];
		if(type === 'delete') {
			// 删除所有的最近搜索
			commit('changeTempleName', '');
			commit('changeSearchName', newArr);
		} else {
			const searchName = state.searchName;
			newArr = searchName.filter(item => item !== temple_name);
			if(temple_name) newArr.unshift(temple_name);
			commit('changeTempleName', temple_name);
			console.log(temple_name,'store')
			commit('changeSearchName', newArr);
		}
		localStorage.searchName = JSON.stringify(newArr);
		return true;
	},
	
	/**
	 * 保存token
	 */
	saveToken({commit, state}, token) {
		localStorage.token = token;
		commit('token', token);
	},
	
	/**
	 * 获取token,没有token 就去授权获取
	 * 顺序 1、state; 2、localStorage；3、url
	 */
	getToken({commit, state, dispatch}) {
		var token = '';
		var search = location.search.substring(1);
		var searchArr = search.split('&');
		var searchObj = {};
		if(searchArr.length !== 0) {
			searchArr.map(item => {
				const itemArr = item.split('=');
				searchObj[itemArr[0]] = decodeURI(itemArr[1]);
			});
		}
		if(localStorage.token||searchObj.token){
            dispatch('saveToken', localStorage.token||searchObj.token);
			return {token: localStorage.token||searchObj.token};
		}else{
			// wxAuthBase();
		}
		// if(state.token) {
		// 	dispatch('saveToken', state.token);
		// 	return {token: state.token};
		// }else if(localStorage.token) {
		// 	dispatch('saveToken', localStorage.token);
		// 	return {token: localStorage.token};
		// }else if(searchObj.token) {
		// 	dispatch('saveToken', searchObj.token);
		// 	return {token: searchObj.token};
		// }else{
			
		// };
	},
	
	/**
	 * 微信支付
	 * @params: data 支付参数，
	 * @params: success 成功回调
	 * @params: error 失败回调
	 */
	wxPay({state}, params) {
		const {data, success, error} = params;
		if(state.client === 0) {
			WeixinJSBridge.invoke('getBrandWCPayRequest', data, function(res){
				if(res.err_msg == "get_brand_wcpay_request:ok" ) {
					// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
					alert('action');
					success({status: true});
				} else {
					error({status: false});
				}
			});
		} else {
			// Toast({
			// 	message: '请在微信内完成支付',
			// 	duration: 1500
			// })
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/actions.js